import api from './index';

let exports = {};

// 登记发票单据（结算单、发票管理）
exports.createInvoiveVoucher = function (params, callback) {// 登记发票单据
    api.post('/finac/invoive/voucher/create/do')
        .data(params)
        .done(callback)
        .go()
};

// 发票信息分页列表
exports.getInvoiceVoucherList = function (params, callback) {// 获取发票单据列表
    api.post('/finac/invoive/voucher/list/get')
        .data(params)
        .done(callback)
        .go()
};

// 发票单据详细信息
exports.getInvoiceVoucherInfo = function (params, callback) {// 获取发票单据信息
    api.get('/finac/invoive/voucher/info/get')
        .params(params)
        .done(callback)
        .go()
};

//收到发票
exports.receiveInvoiceVoucher = function (params, callback) {// 确认发票
    api.post('/finac/invoive/voucher/receive/do')
        .data(params)
        .done(callback)
        .go()
};

// 确认发票
exports.confirmedInvoiceVoucher = function (params, callback) {// 确认发票
    api.post('/finac/invoive/voucher/confirmed/do')
        .data(params)
        .done(callback)
        .go()
};

//作废
exports.invalidateInvoiceVoucher = function (params, result) {// 发票作废
    api.post('/finac/invoive/voucher/invalidate/do')
        .data(params)
        .done(result)
        .go()
};

// 驳回发票
exports.rejectInvoiceVoucher = function (data, callback) {// 删除发票
    api.post('/finac/invoive/voucher/reject/do')
        .data(data)
        .done(callback)
        .go()
};

//删除
exports.deleteInvoiceVoucher = function (params, callback) {// 删除发票
    api.post('/finac/invoive/voucher/delete/do')
        .params(params)
        .done(callback)
        .go()
};

// 与供应商相关的未支付单据列表
exports.getVendorPayVoucherList = function (params, callback) {// 获取供应商支付单据列表
    api.post('/finac/vendor/pay/voucher/list/get')
        .data(params)
        .done(callback)
        .go()
};

// 与服务商相关的未支付单据列表
exports.getServicerPayVoucherList = function (params, callback) {// 获取服务商支付单据列表
    api.post('/finac/servicer/pay/voucher/list/get')
        .data(params)
        .done(callback)
        .go()
};

// 获取支付单据列表
exports.getPayVoucherList = function (data, callback) {// 获取支付单据列表
    api.post('/finac/pay/voucher/list/get')
        .data(data)
        .done(callback)
        .go()
};

//获取支付清单
exports.getPayVoucher = function (params, callback) {// 获取支付单据
    api.get('/finac/pay/voucher/get')
        .params(params)
        .done(callback)
        .go()
};
exports.getPayVoucherByNo = function (params, callback) {// 根据单号获取支付单据信息
    api.get('/finac/pay/voucher/get/by/no')
        .params(params)
        .done(callback)
        .go()
};
// 支付单据补充银行卡信息
exports.updatePayVoucherBankAccInfo = function (data, callback) {// 支付单据补充银行卡信息
    api.post('/finac/pay/voucher/bankAccInfo/update/do')
        .data(data)
        .done(callback)
        .go()
};
// 支付单据审核
exports.auditPayVoucher = function (params, callback) {// 审核支付单据
    api.post('/finac/pay/voucher/audit/do')
        .data(params)
        .done(callback)
        .go()
};
// 指定审核人
exports.assignPayVoucherAuditorInfo = function (params, callback) {// 指定审核人信息
    api.post('/finac/pay/voucher/auditor/info/assign/do')
        .data(params)
        .done(callback)
        .go()
};
//支付单据确认操作
exports.updatePayVoucherConfirmState = function (data, callback) {// 支付确认
    api.post('/finac/pay/voucher/confirmState/update/do')
        .data(data)
        .done(callback)
        .go()
};
// 生成支付单据
exports.savePayVoucher = function (data, callback) {// 保存支付单据
    api.post('/finac/pay/voucher/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 生成预付单
exports.savePrePayVoucher = function (data, callback) {// 保存预付单
    api.post('/finac/pre/pay/voucher/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 生成逆向支付单据
exports.savePayVoucherRefund = function (data, callback) {// 保存逆向支付单据
    api.post('/finac/pay/voucher/refund/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 确认支付
exports.updatePayVoucherPayResult = function (data, callback) {// 修改支付状态
    api.post('/finac/pay/voucher/payResult/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 补录凭证号
exports.updatePayVoucherReservedInfo = function (data, callback) {// 补录凭证号
    api.post('/finac/pay/voucher/reservedInfo/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 删除支付操作
exports.deletePayVoucher = function (params, callback) {// 删除支付单据
    api.post('/finac/pay/voucher/delete/do')
        .params(params)
        .done(callback)
        .go();
};

// 获取指定退款单据的退款操作记录列表
exports.getRefundActRecListByVoucherId = function (params, callback) {// 获取指定退款单据的退款操作记录列表
    api.get('/finac/refund/act/rec/list/get/by/voucherId')
        .params(params)
        .done(callback)
        .go()
};

// 根据阶段id获取阶段已支付金额和已退款金额
exports.getAmountByTrackPhaseId = function (params, callback) {// 根据阶段id获取阶段已支付金额和已退款金额
    api.get('/finac/amount/get/by/trackPhaseId')
        .params(params)
        .done(callback)
        .go()
};

// 对账管理列表0
exports.getFundTransRecList = function (params, callback) {// 获取资金往来记录列表
    api.post('/finac/fund/trans/rec/list/get')
        .data(params)
        .done(callback)
        .go()
};
// 通过对账单id获取资金往来列表信息
exports.getFundTransRecListByCheckVoucherId = function (params, callback) {// 根据对账单id获取资金往来记录列表
    api.post('/finac/fund/trans/rec/list/get/by/checkVoucherId')
        .data(params)
        .done(callback)
        .go()
};
// 对账信息
exports.getFundTransRec = function (params, callback) {// 获取资金往来信息
    api.get('/finac/fund/trans/rec/get')
        .params(params)
        .done(callback)
        .go()
};
// 保存对账单
exports.saveFundTransCheckVoucher = function (data, callback) {// 新增对账单
    api.post('/finac/fund/trans/check/voucher/save/do')
        .data(data)
        .done(callback)
        .go()
};
// 对账单列表查询
exports.getFundTransCheckVoucherList = function (data, callback) {// 获取对账单列表
    api.post('/finac/fund/trans/check/voucher/list/get')
        .data(data)
        .done(callback)
        .go()
};
// 确认对账单
exports.confirmFundTransCheckVoucher = function (data, callback) {// 对账单的确认操作
    api.post('/finac/fund/trans/check/voucher/confirm/do')
        .data(data)
        .done(callback)
        .go()
};
// 拒绝对账单
exports.refuseFundTransCheckVoucher = function (data, callback) {// 对账单的拒绝操作
    api.post('/finac/fund/trans/check/voucher/refuse/do')
        .data(data)
        .done(callback)
        .go()
};
// 删除对账单
exports.deleteFundTransCheckVoucher = function (data, callback) {// 对账单的删除操作
    api.post('/finac/fund/trans/check/voucher/delete/do')
        .data(data)
        .done(callback)
        .go()
};

// 资金往来操作记录列表
exports.getFundTransActRecList = function (data, callback) {// 资金往来操作记录列表
    api.post('/finac/fund/trans/act/rec/list/get')
        .data(data)
        .done(callback)
        .go()
};

// 付款阶段模板
exports.getPayPhaseTplById = function (params, callback) {
    api.get('/finac/pay/phase/tpl/get/by/id')
        .params(params)
        .done(callback)
        .go()
};
// 查詢付款阶段模板分页列表
exports.getPayPhaseTplPagList = function (data, callback) {
    api.post('/finac/pay/phase/tpl/pag/list/get')
        .data(data)
        .done(callback)
        .go()
};
// 保存付款阶段模板
exports.savePayPhaseTpl = function (data, callback) {
    api.post('/finac/pay/phase/tpl/save')
        .data(data)
        .done(callback)
        .go()
};
// 修改付款阶段模板
exports.updatePayPhaseTpl = function (data, callback) {
    api.post('/finac/pay/phase/tpl/update')
        .data(data)
        .done(callback)
        .go()
};
// 删除付款阶段模板
exports.deletePayPhaseTpl = function (data, callback) {
    api.post('/finac/pay/phase/tpl/delete')
        .data(data)
        .done(callback)
        .go()
};
// 启用/禁用付款阶段模板
exports.disabledPayPhaseTpl = function (data, callback) {
    api.post('/finac/pay/phase/tpl/disabled')
        .data(data)
        .done(callback)
        .go()
};
// 查询付款阶段模板项
exports.getPayPhaseTplItemListByFilter = function (data, callback) {
    api.post('/finac/pay/phase/tpl/item/get/by/filter')
        .data(data)
        .done(callback)
        .go()
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/finac.js
// module id = 54
// module chunks = 0